module.exports = new __parcel__URL__("mineko-trust-header.f9bb6d38.png").toString();